import React from "react";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  EMPLOYEE_ID_PATTERN,
  PASSWORD_PATTERN,
} from "../../../utils/validations";
import { AuthWrapper } from "../../../components/AuthWrapper/AuthWrapper";
import InputField from "../../../components/Controls/Input/Input";
import { useDispatch, useSelector } from "react-redux";
import {
  loginWithOTPRequest,
  oTPLoginRequest,
} from "../../../store/authentication/actions";
import { ButtonComponent } from "../../../components/Controls/Button/Button";
import "./login.scss";
import Spinner from "../../../components/Spinner/Spinner";
import { decodeUserNameAndPass } from "../../../utils/Constants";

const Login = ({ intl: { messages } }) => {
  const {loader,lang} = useSelector((state) => state);
  const dispatch = useDispatch();
  const loginSchema = yup.object().shape({
    username: yup
      .string()
      .matches(EMPLOYEE_ID_PATTERN, messages.auth.errors.userNameError)
      .max(50, messages.auth.errors.userNameLength)
      .required(messages.auth.errors.required),
    password: yup
      .string()
      .min(8, messages.auth.errors.passwordLength)
      .matches(PASSWORD_PATTERN, messages.auth.errors.passwordPattern)
      .required(messages.auth.errors.required),
  });

  const formik = useFormik({
    initialValues: localStorage.getItem("reset_password")
      ? { username: "", password: "", required_otp: false }
      : {
          username: "",
          password: "",
        },
    validationSchema: loginSchema,
    onSubmit: (values) => {
      localStorage.setItem("lang", lang);

      if (localStorage.getItem("todo")) { 
        localStorage.removeItem("todo");
      }

      // this second condition is to check if the user after reset password did not log with anouther email
      const encodedString = localStorage.getItem("encodedString");
      const decodedString = decodeUserNameAndPass(encodedString);
      if (
        localStorage.getItem("reset_password") &&
        encodedString &&
        decodedString.split("[userName]")[1].split("[password]")[0] ===
          values.username
      ) {
        dispatch(oTPLoginRequest(values));
      } else {
        dispatch(loginWithOTPRequest(values));
      }
    },
  });

  const renderFormContent = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: 'calc(100% - 35px)' }}>
        <div className="login-form" style={{ width: '100%'}} >
          <div className="login-form_logo"></div>
          <h3 className="login-form_form-header">{messages.auth.login}</h3>
          <form onSubmit={formik.handleSubmit}>
            <InputField
              isRequired={true}
              id="username"
              name="username"
              label={messages.auth.labels.userName}
              value={formik.values.username}
              onChange={formik.handleChange}
              error={formik.touched.username && Boolean(formik.errors.username)}
              helperText={formik.touched.username && formik.errors.username}
              placeholder={messages.auth.placeholders.userName}
            />
            <InputField
              isRequired={true}
              id="password"
              name="password"
              label={messages.auth.labels.password}
              type="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              placeholder={messages.auth.placeholders.password}
              className="mb-4"
            />
            <Link to={"/forgetPassword"}>{messages.auth.forgetPassword}</Link>
            <ButtonComponent
              content={
                <>{loader ? <Spinner color={"white"} /> : messages.auth.login}</>
              }
              variant="contained"
              classes="mx-auto w-100 my-3 form-submit-btn"
              handleClick={formik.handleSubmit}
              color="primary"
              type="submit"
            />
          </form>
        </div>
      </div>
    );
  };

  return (
    <AuthWrapper
      content={renderFormContent()}
      handleSubmit={formik.handleSubmit}
    />
  );
};

export default injectIntl(Login);
